import request from '@/utils/request'

export function saveKangarooQuestions(data) {
  return request({
    url: '/kangaroo-questions/saveQuestions',
    method: 'post',
    data
  })
}

export function kangarooQuAdd(data) {
  return request({
    url: '/kangaroo-questions/single',
    method: 'post',
    data
  })
}

export function kangarooQuPaging(params) {
  return request({
    url: '/kangaroo-questions/paging',
    method: 'get',
    params
  })
}

export function kangarooQuDetail(id) {
  return request({
    url: `/kangaroo-questions/single/${id}`,
    method: 'get'
  })
}

export function kangarooQuUpdate(id, data) {
  return request({
    url: `/kangaroo-questions/${id}`,
    method: 'put',
    data
  })
}

export function kangarooQuDel(id) {
  return request({
    url: `/kangaroo-questions/${id}`,
    method: 'delete'
  })
}

export function kangarooQuBatchDel(ids) {
  return request({
    url: '/kangaroo-questions/batch',
    method: 'delete',
    data: { ids }
  })
}
